import Vue from 'vue';
import Router from 'vue-router';
import i18n from '@/i18n';
import bones from '@/bones/bones';
import bonesconfig from '@/bones/config';

import Registration from '@/views/Registration';
import RegistrationConfirmation from '@/views/RegistrationConfirmation';
import ValetOverview from '@/views/ValetOverview';
import Valet from '@/views/Valet';
import ValetLogin from '@/views/ValetLogin';
import ValetDetails from '@/views/ValetDetails';
import ValetEdit from '@/views/ValetEdit';
import ValetRegistration from '@/views/ValetRegistration';

const { api } = bones;
const { APP_BASE_URL, LANGUAGES } = bonesconfig;

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: APP_BASE_URL,
  routes: [
    //----------------------------------
    // Multi Language Setup
    //----------------------------------
    // {
    //   path: '/eykyact2-uploader',
    //   component: () => import(/* webpackChunkName: "uploader" */ './views/AdminUploader.vue'),
    //   meta: {
    //     ignoreLanguage: true,
    //   },
    // },
    {
      path: '/valet',
      redirect: '/de/valet/',
    },
    {
      path: '/:lang/',
      name: 'registration',
      component: Registration,
      meta: {
        analytics: {
          page: 'form_01',
        },
      },
    },
    {
      path: '/:lang/confirm/:uid',
      name: 'registration-confirmation',
      component: RegistrationConfirmation,
      meta: {
        analytics: {
          page: 'email_verification',
        },
      },
      props: route => ({ uid: route.params.uid }),
    },
    {
      path: '/:lang/valet/',
      name: 'valet',
      component: Valet,
      meta: {
        apiPath: 'global/verify',
      },
    },
    {
      path: '/:lang/login',
      name: 'valet-fallback-login',
      component: ValetLogin,
      meta: {
        apiPath: 'global/verify',
      },
    },
    {
      path: '/:lang/valet/login',
      name: 'valet-login',
      component: ValetLogin,
      meta: {
        apiPath: 'global/verify',
      },
    },
    {
      path: '/:lang/valet/overview',
      name: 'valet-overview',
      component: ValetOverview,
      meta: {
        apiPath: 'global/verify',
      },
    },
    {
      path: '/:lang/valet/details/:uid',
      name: 'valet-details',
      component: ValetDetails,
      meta: {
        apiPath: 'global/verify',
      },
      props: route => ({ uid: route.params.uid }),
    },
    {
      path: '/:lang/valet/edit/:uid',
      name: 'valet-edit',
      component: ValetEdit,
      meta: {
        apiPath: 'global/verify',
      },
      props: route => ({ uid: route.params.uid }),
    },
    {
      path: '/:lang/valet/register',
      name: 'valet-register',
      component: ValetRegistration,
      meta: {
        apiPath: 'global/verify',
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeResolve(async (to, from, next) => {
  const ignoreLanguage = to.meta.ignoreLanguage || false;
  const language = (to.params.lang) ? to.params.lang : to.query.lang || '';

  if (!ignoreLanguage && LANGUAGES.length > 1 && !LANGUAGES.includes(language)) {
    const navigatorLang = navigator.language.substr(0, 2);
    const fallbackLanguage = LANGUAGES.includes(navigatorLang) ? navigatorLang : LANGUAGES[0];
    return next({ path: `/${fallbackLanguage}/`, replace: true });
  }

  // FIXME: remove this ugly hack
  if (language !== 'de') {
    return next({ path: '/de/', replace: true });
  }

  if (i18n.locale !== language) {
    const requestedLanguage = LANGUAGES.includes(language) ? language : LANGUAGES[0];
    const messages = await import(/* webpackChunkName: "i18n-[request]" */ `@/locales/${requestedLanguage}`);
    i18n.setLocaleMessage(requestedLanguage, messages.default);
    document.documentElement.lang = requestedLanguage;
    i18n.locale = requestedLanguage;
    Vue.nextTick(() => {
      i18n.silentTranslationWarn = false;
    });
  }

  if (to.meta.title) {
    document.querySelector('title').textContent = i18n.t(to.meta.title);
  }

  if (bones.analytics) {
    const analyticData = (to.meta || {}).analytics || {};
    analyticData.url = to.fullPath;
    bones.analytics.trackPage(analyticData);
  }

  // const RENDERED_EVENT = new Event('bones-rendered');
  if (to.meta.apiPath) {
    const data = await api.get(to.meta.apiPath);
    if (data) {
      bones.data = data;
      next();
      // document.dispatchEvent(RENDERED_EVENT);
      return null;
    }
  }
  next();
  // document.dispatchEvent(RENDERED_EVENT);
  return null;
});

export default router;
